import React from "react";

const reviews = [
    { name: "Kartik Arora", role: "Health-supplement manufacturer · Delhi", quote: "The purity and freshness of Ostrich Foods' powders are unmatched. We need ingredients that are chemical-free and rich in nutrition — and they deliver, batch after batch." },
    { name: "Divender Kumar", role: "Bakery owner · Chandigarh", quote: "Ostrich has transformed how we use fruit and vegetable powders. The flavours feel like real fruit — but with the convenience of a clean pantry ingredient." },
    { name: "Rachael Müller", role: "Procurement, plant-protein brand · Berlin", quote: "Documentation, particle size, lead times — everything is exactly what European compliance asks for. They get B2B." },
    { name: "Imran Faisal", role: "Founder, snack startup · Dubai", quote: "We tested four suppliers for tomato powder. Ostrich was the cleanest taste and the most consistent colour. We've been loyal since." },
];

const Testimonials = () => {
    return (
        <section
            data-testid="testimonials-section"
            className="py-24 md:py-36 bg-sun-bg relative"
        >
            <div className="container-x relative">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-20 border-b border-sun-line pb-8">
                    <div>
                        <div className="overline mb-4">— Voices</div>
                        <h2 className="font-heading text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-[-0.02em] text-sun-ink">
                            What buyers
                            <br />
                            <span className="display-italic text-gradient">actually</span> say.
                        </h2>
                    </div>
                    <p className="md:max-w-sm text-sun-inkSoft text-sm leading-relaxed">
                        Reviews from food formulators, bakery owners and brand procurement
                        teams we ship to every week.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
                    {reviews.map((r, i) => (
                        <figure
                            key={r.name}
                            data-testid={`testimonial-${i}`}
                            className="bg-white border border-sun-line rounded-3xl p-8 md:p-12 flex flex-col justify-between hover:shadow-xl hover:shadow-sun-orange/10 transition-shadow"
                        >
                            <div>
                                <div className="font-heading display-italic text-7xl text-sun-orange leading-none mb-4 select-none">
                                    “
                                </div>
                                <blockquote className="font-heading text-2xl md:text-3xl leading-snug tracking-tight text-sun-ink">
                                    {r.quote}
                                </blockquote>
                            </div>
                            <figcaption className="mt-10 pt-6 border-t border-sun-line flex items-center justify-between">
                                <div>
                                    <div className="font-medium text-sun-ink">{r.name}</div>
                                    <div className="overline mt-1">{r.role}</div>
                                </div>
                                <div className="font-mono text-[10px] uppercase tracking-[0.32em] text-sun-muted">
                                    Letter / {String(i + 1).padStart(2, "0")}
                                </div>
                            </figcaption>
                        </figure>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
